import React from "react";

import "../styles/WhyUsSection.css";

import {
  FaBiking,
  FaMedal,
  FaSmile,
  FaLeaf,
  FaShieldAlt,
  FaBolt,
} from "react-icons/fa";

const WhyUsSection = () => {

  const reasons = [

    {
      icon: <FaBiking />,
      title: "Premium Bicycles",
      text: "Built with performance, durability, and style for riders who crave adventure and smooth rides.",
    },

    {
      icon: <FaBolt />,
      title: "Luxury Ride-On Toys",
      text: "Exciting electric ride-on toys designed for kids with premium looks, lights, comfort, and fun.",
    },

    {
      icon: <FaMedal />,
      title: "Trusted Brand",
      text: "SAC MTB is trusted by thousands of riders and families for quality products and reliable service.",
    },

    {
      icon: <FaShieldAlt />,
      title: "Built for Safety",
      text: "From strong frames to secure ride systems, every product is engineered with safety first.",
    },

    {
      icon: <FaSmile />,
      title: "Customer Happiness",
      text: "We focus on experience, support, and satisfaction to make every customer journey memorable.",
    },

    {
      icon: <FaLeaf />,
      title: "Eco-Friendly Vision",
      text: "Our passion for mobility also supports a cleaner and greener future for the next generation.",
    },

  ];

  return (

    <section className="whyus-section">

      {/* TOP */}

      <div className="whyus-header">

        <span className="whyus-tag">
          WHY SAC MTB
        </span>

        <h2 className="whyus-title">

          Built For Riders.
          <br />
          Designed For Families.

        </h2>

        <p className="whyus-subtext">

          Premium bicycles and luxury ride-on toys
          crafted with performance, safety, style,
          and unforgettable riding experiences.

        </p>

      </div>

      {/* GRID */}

      <div className="whyus-grid">

        {reasons.map((reason, index) => (

          <div
            key={index}
            className="whyus-card"
          >

            {/* ICON */}

            <div className="whyus-icon">
              {reason.icon}
            </div>

            {/* CONTENT */}

            <h3>
              {reason.title}
            </h3>

            <p>
              {reason.text}
            </p>

          </div>

        ))}

      </div>

    </section>
  );
};

export default WhyUsSection;